import React from 'react';

/* Components ---------------------------*/
import Menu from './Menu';

const Header = () => {
    return (
            <header>
                <Menu />
            </header>
    );
}

export default Header;
